<template>

  <section class="int-section">

    <div class="int-section__accent" />

    <div class="int-section__inner">

      <header class="int-section__head">

        <div class="int-section__head-left">

          <div class="int-section__icon" aria-hidden="true">

            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />

            </svg>

          </div>

          <div>

            <h2 class="int-section__title">{{ t('integracao.forms.sectionTitle') }}</h2>

            <p class="int-section__desc">{{ t('integracao.forms.sectionDesc') }}</p>

          </div>

        </div>

        <button type="button" class="int-section__cta" @click="openCreate">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />

          </svg>

          {{ t('integracao.forms.newForm') }}

        </button>

      </header>



      <div v-if="loading" class="int-section__loading">

        <span class="int-section__spinner" aria-hidden="true" />

        {{ t('common.loading') }}

      </div>



      <div v-else-if="!forms.length" class="int-section__empty">

        <div class="int-section__empty-icon" aria-hidden="true">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">

            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />

          </svg>

        </div>

        <p>{{ t('integracao.forms.empty') }}</p>

      </div>



      <div v-else class="int-item-list">

        <article v-for="f in forms" :key="f.id" class="int-item-card">

          <div class="int-item-card__main">

            <h3 class="int-item-card__title">{{ f.nome }}</h3>

            <div class="int-item-card__meta">

              <span :class="['int-badge', f.ativo ? 'int-badge--on' : 'int-badge--off']">

                <span class="int-badge__dot" aria-hidden="true" />

                {{ f.ativo ? t('integracao.forms.active') : t('integracao.forms.inactive') }}

              </span>

              <span v-if="f.origemLabel" class="int-item-card__origin">{{ f.origemLabel }}</span>

            </div>

          </div>

          <div class="int-item-card__actions">

            <button type="button" class="int-action-btn int-action-btn--primary" @click="copyUrl(f.publicToken)">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

                <path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />

              </svg>

              {{ t('integracao.forms.copyUrl') }}

            </button>

            <button type="button" class="int-action-btn" @click="copyIframe(f.publicToken)">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

                <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />

              </svg>

              {{ t('integracao.forms.copyIframe') }}

            </button>

            <button type="button" class="int-action-btn" @click="openEdit(f)">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

                <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />

              </svg>

              {{ t('common.edit') }}

            </button>

            <button type="button" class="int-action-btn int-action-btn--danger" @click="removeForm(f)">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

                <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />

              </svg>

              {{ t('common.delete') }}

            </button>

          </div>

        </article>

      </div>

    </div>



    <LeadCaptureFormEditorModal

      :open="editorOpen"

      :initial="editing"

      :saving="saving"

      @close="editorOpen = false"

      @save="onSave"

    />

  </section>

</template>



<script setup>

import { ref, onMounted } from 'vue'

import { useI18n } from 'vue-i18n'

import { useToast } from 'vue-toastification'

import api from '@/services/api'

import LeadCaptureFormEditorModal from './LeadCaptureFormEditorModal.vue'

import { publicFormUrl, iframeSnippet } from '@/utils/leadFormFieldConfig'
import '@/assets/styles/integration-section.css'
import '@/assets/styles/integration-modal.css'



const props = defineProps({

  workspaceId: { type: Number, required: true }

})



const { t } = useI18n()

const toast = useToast()



const forms = ref([])

const loading = ref(false)

const editorOpen = ref(false)

const editing = ref(null)

const saving = ref(false)



async function load () {

  loading.value = true

  try {

    const { data } = await api.get(`/workspace/${props.workspaceId}/lead-forms`)

    forms.value = Array.isArray(data) ? data : []

  } catch (e) {

    toast.error(e.response?.data?.error || t('integracao.forms.loadError'))

  } finally {

    loading.value = false

  }

}



function openCreate () {

  editing.value = null

  editorOpen.value = true

}



function openEdit (f) {

  editing.value = f

  editorOpen.value = true

}



async function onSave (payload) {

  saving.value = true

  try {

    if (editing.value?.id) {

      await api.put(`/workspace/${props.workspaceId}/lead-forms/${editing.value.id}`, payload)

      toast.success(t('integracao.forms.updated'))

    } else {

      await api.post(`/workspace/${props.workspaceId}/lead-forms`, payload)

      toast.success(t('integracao.forms.created'))

    }

    editorOpen.value = false

    await load()

  } catch (e) {

    toast.error(e.response?.data?.error || t('integracao.forms.saveError'))

  } finally {

    saving.value = false

  }

}



async function removeForm (f) {

  if (!confirm(t('integracao.forms.deleteConfirm', { name: f.nome }))) return

  try {

    await api.delete(`/workspace/${props.workspaceId}/lead-forms/${f.id}`)

    toast.success(t('integracao.forms.deleted'))

    await load()

  } catch (e) {

    toast.error(e.response?.data?.error || t('integracao.forms.deleteError'))

  }

}



async function copyUrl (token) {

  await navigator.clipboard.writeText(publicFormUrl(token))

  toast.success(t('integracao.forms.copied'))

}



async function copyIframe (token) {

  await navigator.clipboard.writeText(iframeSnippet(token))

  toast.success(t('integracao.forms.copied'))

}



onMounted(load)

</script>
